import { render } from "./locale-dropdown.vue?vue&type=template&id=d25156e0"
import script from "./locale-dropdown.vue?vue&type=script&lang=js"
export * from "./locale-dropdown.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./locale-dropdown.vue?vue&type=custom&index=0&blockType=i18n&lang=json5"
if (typeof block0 === 'function') block0(script)
import block1 from "./locale-dropdown.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__